import { render, staticRenderFns } from "./WorkplaceBlockedModal.vue?vue&type=template&id=4cc7d4bf&"
import script from "./WorkplaceBlockedModal.vue?vue&type=script&lang=js&"
export * from "./WorkplaceBlockedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports